import type { SorterResult, SortOrder } from "antd/es/table/interface";
import { OrderDirection } from "../enums";

type TableSorting<OrderBy> = {
  orderBy?: OrderBy[];
  orderDirections?: OrderDirection[];
};

/** Kept on the column definition so that the table sorter change can read it back from there. */
type ColumnSorting<OrderBy> = {
  orderBy: OrderBy;
};

export const getOrderDirectionToSortOrder = (orderDirection: OrderDirection) =>
  orderDirection === OrderDirection.ASC ? "ascend" : "descend";

export const getOrderDirection = (sortOrder: SortOrder): OrderDirection =>
  sortOrder === "descend" ? OrderDirection.DESC : OrderDirection.ASC;

export const sortableColumnProps = <OrderBy>(orderByColumn: OrderBy, data?: TableSorting<OrderBy>) => {
  const orderByIndex = data?.orderBy?.indexOf(orderByColumn) ?? -1;
  const orderDirection = orderByIndex < 0 ? undefined : data?.orderDirections?.[orderByIndex];

  return {
    sorter: true,
    sortOrder: orderDirection ? getOrderDirectionToSortOrder(orderDirection) : undefined,
    orderBy: orderByColumn,
  } satisfies ColumnSorting<OrderBy> & { sorter: boolean; sortOrder?: SortOrder };
};

export const getTableSorting = <OrderBy>(
  sorter: SorterResult<any> | SorterResult<any>[],
): Required<TableSorting<OrderBy>> => {
  const orderBy: OrderBy[] = [];
  const orderDirections: OrderDirection[] = [];

  (Array.isArray(sorter) ? sorter : [sorter]).forEach((sorterItem) => {
    const columnSorting = sorterItem.column as Partial<ColumnSorting<OrderBy>> | undefined;

    if (!columnSorting?.orderBy || !sorterItem.order) {
      return;
    }

    orderBy.push(columnSorting.orderBy);
    orderDirections.push(getOrderDirection(sorterItem.order));
  });

  return { orderBy, orderDirections };
};
